import { render, staticRenderFns } from "./CProfileBirthday.vue?vue&type=template&id=085816e6&"
import script from "./CProfileBirthday.vue?vue&type=script&lang=js&"
export * from "./CProfileBirthday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports